// import React, { createContext, useContext, useRef, useState } from "react";
// import { downloadAssetsFile, startDownloadAssets } from "../utils/download";
// import { useSocket } from "../context/SocketContext";

// const DownloadAssetsContext = createContext(null);

// export const DownloadAssetsProvider = ({ children }) => {
//   const [downloadingAssets, setDownloadingAssets] = useState([]);
//   const socketUnsubRef = useRef({}); // unsubscribe handlers
//   const { subscribe } = useSocket();

//   /* ----------------------------------
//      Start Download
//   ---------------------------------- */
//   const startDownload = async (payload) => {
//     try {
//       const job = await startDownloadAssets(payload);
//       const downloadId = job.downloadId;

//       setDownloadingAssets((prev) => [
//         ...prev,
//         {
//           id: downloadId,
//           payload,
//           status: job.status || "PENDING",
//           progress: 0,
//         },
//       ]);
// debugger
//       // 🔔 subscribe to socket updates
//       subscribeToDownload(downloadId, payload);
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   /* ----------------------------------
//      Subscribe to socket events
//   ---------------------------------- */
//   const subscribeToDownload = (downloadId, payload) => {
//     debugger
//     if (socketUnsubRef.current[downloadId]) return;

//     const unsubscribe = subscribe(
//       `/topic/download-status/${downloadId}`,
//       async (data) => {
//         const { status, progress } = data;
// debugger
//         if (status === "PROCESSING") {
//           updateStatus(downloadId, "PROCESSING", progress);
//         }

//         if (status === "READY") {
//           cleanup(downloadId);
//           await downloadAssetsFile({ ...payload, downloadId });
//           updateStatus(downloadId, "DONE", 100);
//         }

//         if (status === "FAILED") {
//           cleanup(downloadId);
//           updateStatus(downloadId, "FAILED");
//         }
//       },
//     );

//     socketUnsubRef.current[downloadId] = unsubscribe;
//   };

//   /* ----------------------------------
//      Cleanup socket subscription
//   ---------------------------------- */
//   const cleanup = (downloadId) => {
//     const unsub = socketUnsubRef.current[downloadId];
//     if (unsub) {
//       unsub();
//       delete socketUnsubRef.current[downloadId];
//     }
//   };

//   /* ----------------------------------
//      Update Status
//   ---------------------------------- */
//   const updateStatus = (id, status, progress = 0) => {
//     setDownloadingAssets((prev) =>
//       prev.map((d) =>
//         d.id === id ? { ...d, status, progress } : d,
//       ),
//     );
//   };

//   /* ----------------------------------
//      Remove item
//   ---------------------------------- */
//   const removeDownload = (id) => {
//     cleanup(id);
//     setDownloadingAssets((prev) =>
//       prev.filter((d) => d.id !== id),
//     );
//   };

//   return (
//     <DownloadAssetsContext.Provider
//       value={{
//         startDownload,
//         downloadingAssets,
//         removeDownload,
//       }}
//     >
//       {children}
//     </DownloadAssetsContext.Provider>
//   );
// };

// export const useDownloadAssets = () =>
//   useContext(DownloadAssetsContext);

import React, { createContext, useContext, useRef, useState } from "react";
import axios from "axios";
import { DOWNLOAD_STATUS_API } from "../Components/DAM_API/urls";
import { downloadAssetsFile, startDownloadAssets } from "../utils/download";

const DownloadAssetsContext = createContext(null);

export const DownloadAssetsProvider = ({ children }) => {
  const [downloadingAssets, setDownloadingAssets] = useState([]);
  const pollingMapRef = useRef({}); // store intervals by tempId

  /* ----------------------------------
     Start Download
  ---------------------------------- */
  const startDownload = async (payload) => {
    var tempId;
    try {
      const job = await startDownloadAssets(payload);
      tempId = job.downloadId;
      setDownloadingAssets((prev) => [
        ...prev,
        { id: tempId, payload, status: "STARTING" },
      ]);

      // 🕒 async processing
      if (job.status === "PENDING") {
        updateStatus(tempId, "PENDING");
        startPolling(job.downloadId, payload, tempId);
      }
    } catch (err) {
      console.error(err);
      updateStatus(tempId, "FAILED");
    }
  };

  /* ----------------------------------
     Poll Status (5s)
  ---------------------------------- */
  const startPolling = (downloadId, payload, tempId) => {
    stopPolling(tempId);

    pollingMapRef.current[tempId] = setInterval(async () => {
      try {
        const res = await axios.get(`${DOWNLOAD_STATUS_API}/${downloadId}`);
        if (res.data?.status === "READY") {
          stopPolling(tempId);
          await downloadAssetsFile({ ...payload, downloadId });
          updateStatus(tempId, "DONE");
        }

        if (res.data?.status === "FAILED") {
          stopPolling(tempId);
          updateStatus(tempId, "FAILED");
        }

        if (res.data?.status === "ZIPPING") {
          updateStatus(tempId, "ZIPPING", res.data.progress);
        }

        if (res.data?.status === "PROCESSING") {
          updateStatus(tempId, "PROCESSING", res.data.progress);
        }
      } catch (err) {
        console.error("Polling error", err);
      }
    }, 3000);
  };

  /* ----------------------------------
     Stop Polling
  ---------------------------------- */
  const stopPolling = (tempId) => {
    const interval = pollingMapRef.current[tempId];
    if (interval) {
      clearInterval(interval);
      delete pollingMapRef.current[tempId];
    }
  };

  /* ----------------------------------
     Update Status
  ---------------------------------- */
  const updateStatus = (id, status, progress = 0) => {
    setDownloadingAssets((prev) =>
      prev.map((d) => (d.id === id ? { ...d, status, progress: progress } : d)),
    );
  };

  /* ----------------------------------
     Remove item (optional)
  ---------------------------------- */
  const removeDownload = (id) => {
    stopPolling(id);
    setDownloadingAssets((prev) => prev.filter((d) => d.id !== id));
  };

  return (
    <DownloadAssetsContext.Provider
      value={{
        startDownload,
        downloadingAssets,
        removeDownload,
      }}
    >
      {children}
    </DownloadAssetsContext.Provider>
  );
};

export const useDownloadAssets = () => useContext(DownloadAssetsContext);
